// src/utils/lang.js
import wallet from '@/store/wallet';

export function getCurrentLang() {
  // 优先用响应式状态，其次用 localStorage，最后默认 en
  return (wallet.state && wallet.state.lang) ||
         localStorage.getItem('lang') ||
         'en';
}
